import React, { useState, useEffect, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
import { systemAPI } from '../../../../apis';
import { AddUserPop, EditUserPop } from '../Pops';
import Results from '../Results';
import { UserTable } from '../Table';
import { UserToolBar } from '../ToolBar';
import { addLoginAction, rewriteSettingRequestParams } from '../../../../utils/check';
import { hospitalWardListFunc } from '../../../../utils/hospitalWardList';
import { LOGIN_INFO, SETTING_EDIT_TABLE } from '../../../../comm/constant';
import { updateLoginInfoAction } from '../../../../redux/actions';
import { userRoleList } from '../../../../utils/userRole';
import { roleIdE } from '../../../../comm/RoleMap';
import { mutationUpdateOtherLoginInfo } from '../../../../utils/handleUpdateOtherLoginInfo';

const useStyles = makeStyles((theme) => ({
  results: {
    padding: '1.875rem',
  },
}));
const User = ({ userRole, loginInfo, updateLoginInfo }) => {
  const classes = useStyles();
  const PAGESIZE = 20;
  const [count, setCount] = useState(null);

  const [RoleList, setRoleList] = useState([]);
  const getSysRoleList = async () => {
    const { result } = await systemAPI.getSysUserRoleItem({ userId: loginInfo.userId });
    setRoleList(result);
  };

  const [WardDropList, setWardDropList] = useState();
  const getSysWardDropList = async () => {
    const { result } = await systemAPI.getSysWardDropList({ userId: loginInfo.userId });
    setWardDropList(result);
  };

  const [hospitalNameValue, setHospitalNameValue] = useState(null);
  const [wardNameValue, setWardNameValue] = useState(null);
  const [WardItemList, setWardItemList] = useState([]);
  const getSysWardItemList = async () => {
    const { result } = await systemAPI.getSysWardItemList({
      userId: loginInfo.userId,
      corpId: loginInfo.corpID,
      hospId: loginInfo.hospitalId,
    });
    setWardItemList(result);
  };

  const [UserList, setUserList] = useState([]);
  const getSysUserList = async (pageSize, pageNo) => {
    const { result } =
      (await systemAPI.getSysUserList({
        pageSize: pageSize,
        pageNo: pageNo,
        corpId: loginInfo.corpID,
        hospId: loginInfo.hospitalId,
        corpName: searchValue,
        status: StatusValue,
        role: RoleNameValue,
        wardId: wardNameValue,
        hospitalId: hospitalNameValue,
        userId: loginInfo.userId,
      })) ?? {};
    setCount(result.count ?? 0);
    const newWardList = [...UserList.slice(0, (pageNo - 1) * pageSize), ...result.data];
    setUserList(newWardList);
    return result?.data;
  };

  const tableRef = useRef(null);
  const createSysUser = async (data) => {
    try {
      const { result } = await systemAPI.createSysUser(data);
      const pageList = await getSysUserList(PAGESIZE, 1);
      closeAddPop();
      tableRef.current.scrollTo(0, 0);
      setHideIndex(pageList.findIndex((item) => item.userId === result.id));
    } catch (error) {
      console.log('-----User error-----', error);
    }
  };

  const updateSysUser = async (data) => {
    try {
      await systemAPI.updateSysUser(data);
      await updateMenu(data);
      const pageNo = Math.ceil((editIndex + 1) / PAGESIZE);
      const pageList = await getSysUserList(PAGESIZE, pageNo);
      closeEditPop();
      const index = pageList.findIndex((item) => item.userId === data.userId);
      setHideIndex(index > -1 ? (pageNo - 1) * PAGESIZE + index : index);
    } catch (error) {}
  };

  const [hideIndex, setHideIndex] = useState(null);
  const updateMenu = async ({ userId, roleId, corpId, hospitalId, wardId }) => {
    if (loginInfo.userId === userId) {
      if (userRoleList.getRoleType(userRole, null, null, loginInfo.userId) === roleId) {
        sessionStorage.setItem(SETTING_EDIT_TABLE, true);
      }
      const newLoginInfo = {
        ...loginInfo,
        corpID: corpId,
        hospitalId: hospitalId,
        wardId: wardId,
      };
      localStorage.setItem(LOGIN_INFO, JSON.stringify(newLoginInfo));
      mutationUpdateOtherLoginInfo();
      updateLoginInfo(newLoginInfo);
      addLoginAction();
    }
  };

  const requestHttp = async () => {
    try {
      await getSysWardDropList();
      await getSysRoleList();
      await getSysWardItemList();
    } catch (error) {
      setUserList([]);
      console.log('-----User error-----', error);
    }
  };

  // status drop
  const [StatusList] = useState([
    { text: 'Active', value: 1 },
    { text: 'InActive', value: 0 },
  ]);
  const [StatusValue, setStatusValue] = useState(null);

  // role name drop
  const RoleNameList = useMemo(() => {
    if (RoleList) {
      return _.map(RoleList, (item) => ({ text: item.roleName, value: item.roleId, roleTypeId: item.roleTypeId }));
    }
  }, [RoleList]);
  const [RoleNameValue, setRoleNameValue] = useState(null);

  // WardToolBar
  const selectList = [
    {
      itemList: [{ text: 'All', value: '' }, ...StatusList],
      value: StatusValue,
      onChange: (value) => {
        setStatusValue(value);
      },
    },
    {
      itemList: [
        { text: 'All', value: '' },
        ...(() => {
          const result = [];
          RoleNameList?.forEach((item) => {
            if (item.value !== roleIdE.SA) {
              result.push({ text: item.text, value: item.text, roleTypeId: item.roleTypeId });
            }
          });
          return result;
        })(),
      ],
      value: RoleNameValue,
      onChange: (value) => {
        setRoleNameValue(value);
      },
    },
    {
      itemList: [{ text: 'All', value: '' }, ...(hospitalWardListFunc.getAllHospitalSelectFormat(WardItemList) ?? [])],
      value: hospitalNameValue,
      onChange: (value) => {
        setHospitalNameValue(value);
        value === '' && setWardNameValue('');
      },
    },
    {
      itemList: [
        { text: 'All', value: '' },
        ..._.sortBy(hospitalWardListFunc.getHospitalAllWardUseIdSelectFormat(WardItemList, hospitalNameValue), [
          'text',
        ]),
      ],
      value: wardNameValue,
      onChange: (value) => {
        setWardNameValue(value);
      },
    },
  ];
  const [isAddPop, setIsAddPop] = useState(false);
  const closeAddPop = () => {
    setIsAddPop(false);
  };
  const addClick = () => {
    setIsAddPop(true);
  };

  // WardTable
  const [isEditPop, setEditPop] = useState(false);
  const [editIndex, setEditIndex] = useState(-1);
  const editClick = (item, index) => {
    setEditIndex(index);
    setEditPop(true);
  };
  const closeEditPop = () => {
    setEditPop(false);
  };

  const itemListsCtr = () => ({
    roleName: RoleNameList,
    status: StatusList,
    hospitalWardList: WardDropList,
    RoleList: RoleList,
  });

  const editAllDataCtr = () => {
    return editIndex > -1 ? UserList[editIndex] : {};
  };

  const [searchValue, setSearchValue] = useState(null);
  const searchClick = (val) => {
    setSearchValue(val);
  };

  useEffect(() => {
    (async () => {
      if (
        RoleNameValue !== null ||
        StatusValue !== null ||
        searchValue !== null ||
        wardNameValue !== null ||
        hospitalNameValue !== null
      ) {
        try {
          await getSysUserList(PAGESIZE, 1);
          tableRef.current.scrollTo(0, 0);
        } catch {}
      }
    })();
  }, [RoleNameValue, StatusValue, searchValue, wardNameValue, hospitalNameValue]);

  const nextPageCall = async (pageSize, pageNo) => {
    try {
      if (count === null || count !== UserList.length) {
        if (count === null) {
          await requestHttp();
        }
        await getSysUserList(pageSize, pageNo);
      }
    } catch (error) {
      console.log('-----user error-----', error);
    }
  };

  const allWardId = useMemo(() => {
    return hospitalWardListFunc.getAllWardId(WardDropList) ?? [];
  }, [WardDropList]);
  const isWardIc = useMemo(() => {
    return userRoleList.isWardIc(userRole, null, null, loginInfo.userId);
  }, [userRole]);

  return (
    <>
      <UserToolBar
        selectList={selectList}
        addClick={addClick}
        searchClick={searchClick}
        onChange={_.debounce((val) => {
          setSearchValue(val);
        }, 500)}
        pageSize={PAGESIZE}
      />
      <Results length={count || 0} className={classes.results} />
      <UserTable
        editClick={editClick}
        allData={UserList}
        nextPageCall={nextPageCall}
        pageSize={PAGESIZE}
        hideIndex={hideIndex}
        setHideIndex={setHideIndex}
        editDisabledFunc={(item, index) => {
          return isWardIc && !allWardId.includes(item?.wardId);
        }}
        ref={tableRef}
      />
      {isAddPop ? (
        <AddUserPop open={isAddPop} closePop={closeAddPop} confirmClick={createSysUser} itemLists={itemListsCtr()} />
      ) : (
        ''
      )}
      {isEditPop ? (
        <EditUserPop
          open={isEditPop}
          closePop={closeEditPop}
          itemLists={itemListsCtr()}
          allData={editAllDataCtr()}
          confirmClick={updateSysUser}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default connect(
  (state) => ({
    userRole: state.userRole,
    loginInfo: state.loginInfo,
  }),
  {
    updateLoginInfo: updateLoginInfoAction,
  }
)(User);
